import * as React from 'react'
import { Card } from 'reactstrap'

import SignupApp from './index.web'
import ContentWrapper from '../../../Web/common/contentWrapper.web'
import { translate } from '../../i18n'

const SignupView: any = () => {
  return (
    <ContentWrapper>
      <div className="content-heading">
        <div>{translate('device.allDevices')}</div>
      </div>
      <Card className="card-default">
        <Card className="card-default"></Card>
        <SignupApp />{' '}
      </Card>
    </ContentWrapper>
  )
}

export default SignupView
